import React, { useState } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import {
  errorMessage,
  forgetPassword,
  forgetPasswordContainer,
  subtitleContainer,
  subtitle1,
  subtitle2,
  content,
  logo as logoStyle,
} from "./Login.style";
import { useNavigate, useLocation } from "react-router-dom";
import ButtonLoading from "../components/ButtonLoading";
import { registerWithEmailAndPassword } from "../api/user";
import Input from "../components/Input";
import { toast } from "react-toastify";
import logoImg from "../assets/logo-blue.png";
import AuthSidePanel from "../components/AuthSidePanel";
import { MenuItem, Select, Typography } from "@mui/material";
import { colors } from "../utils/constants";

export default function Register() {
  let navigate = useNavigate();
  let location = useLocation();

  let from = location.state?.from?.pathname || "/login";

  const [name, setName] = useState(
    location.state?.userData ? JSON.parse(location.state?.userData).name : ""
  );
  const [email, setEmail] = useState("");
  const [ddi, setDdi] = useState("55");
  const [whatsapp, setWhatsapp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState(false);

  const ddiOptions = [
    { code: "55", label: "🇧🇷" },
    { code: "351", label: "🇵🇹" },
    { code: "1", label: "🇺🇸" },
    { code: "44", label: "🇬🇧" },
  ];

  const register = async () => {
    setLoading(true);
    setLoginError(false);

    registerWithEmailAndPassword(
      name,
      email,
      password,
      ddi.replace("+", ""),
      whatsapp
    )
      .then(() => {
        toast.success("Cadastro realizado com sucesso");
        navigate(from, { replace: true });
        setLoginError(false);
      })
      .catch((e) => {
        if (e.code === "auth/email-already-in-use") {
          toast.error("Email ja existe");
          return;
        }

        if (e.code === "auth/invalid-email") {
          toast.error("Email inválido");
          return;
        }

        setLoginError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      toast.error("As senhas devem ser iguais");
      return;
    }

    if (password.length < 6) {
      toast.error("A sua senha deve ter pelo menos 6 digitos");
      return;
    }

    register();
  };

  const formatPhone = (value: string) => {
    const cleaned = value.replace(/\D/g, "").slice(0, 11);
    if (ddi === "+55") {
      if (cleaned.length <= 2) return `(${cleaned}`;
      if (cleaned.length <= 6)
        return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2)}`;
      if (cleaned.length <= 10)
        return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 6)}-${cleaned.slice(
          6
        )}`;
      return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 7)}-${cleaned.slice(
        7,
        11
      )}`;
    }
    return cleaned;
  };

  const handleChangeWhatsapp = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value.replace(/\D/g, "");
    setWhatsapp(rawValue);
  };

  return (
    <Box style={styles.container}>
      <CssBaseline />

      <AuthSidePanel
        headline="Crie sua conta e comece a emitir certificados hoje."
        subtext="Leva menos de dois minutos para configurar seu primeiro evento."
      />

      <Box sx={content}>
        <Box style={styles.formCol}>
          <img src={logoImg} style={logoStyle} alt="Logo" />

          <Box sx={subtitleContainer}>
            <span style={subtitle1}>Bem-vindo!</span>
            <span style={subtitle2}>Crie sua conta e aproveite!</span>
          </Box>

          <Box component="form" onSubmit={handleSubmit} style={styles.form}>
            <Input
              title={"NOME"}
              placeholder={"Nome"}
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />

            <Input
              title={"E-MAIL"}
              placeholder={"E-mail"}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
            />

            <Box style={styles.phoneRow}>
              <Box style={styles.ddiWrap}>
                <Typography
                  component="span"
                  variant="subtitle2"
                  sx={styles.fieldLabel}
                >
                  DDI
                </Typography>
                <Select
                  value={ddi}
                  onChange={(e) => setDdi(e.target.value)}
                  sx={{ width: "100%", borderRadius: "8px" }}
                >
                  {ddiOptions.map((option) => (
                    <MenuItem key={option.code} value={option.code}>
                      {option.code} ({option.label})
                    </MenuItem>
                  ))}
                </Select>
              </Box>
              <Box style={styles.whatsappWrap}>
                <Input
                  title="WHATSAPP"
                  placeholder="Número de telefone"
                  value={formatPhone(whatsapp)}
                  onChange={handleChangeWhatsapp}
                  type="tel"
                  required
                />
              </Box>
            </Box>

            <Input
              title={"SENHA"}
              placeholder={"Senha"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              type="password"
            />

            <Input
              title={"CONFIRMAR SENHA"}
              placeholder={"Confirmar senha"}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              type="password"
            />

            {loginError && (
              <span style={errorMessage}>
                Erro ao realizar login. Verifique seus dados e tente novamente.
              </span>
            )}

            <ButtonLoading
              label="Cadastrar"
              loading={loading}
              className="landing-hover-lift"
              style={styles.primaryButton}
            />

            <div style={{ ...forgetPasswordContainer, textAlign: "right" }}>
              <Link href="/login" variant="body2" style={forgetPassword}>
                Já tenho conta
              </Link>
            </div>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

const styles: any = {
  container: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "row",
  },

  formCol: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  form: {
    marginTop: 8,
    width: "100%",
    maxWidth: 460,
    padding: 0,
  },

  fieldLabel: {
    fontSize: "12px",
    fontWeight: 500,
    color: "#9FA2B4",
    display: "flex",
  },

  phoneRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
    gap: 8,
    width: "100%",
  },

  ddiWrap: {
    width: 110,
    flexShrink: 0,
  },

  whatsappWrap: {
    flex: 1,
  },

  primaryButton: {
    marginTop: 24,
    width: "100%",
    height: 52,
    borderRadius: 100,
    color: colors.white,
  },
};
